import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import PilotFaq from "../pilot-faq";
import { Button } from "@cars24/turbo-web/lib/button";
import { ArrowIcon } from "@cars24/turbo-web/lib/icons/arrow-icon";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { challanFaqClicked } from "./tracking";
import { NUMBER } from "../../../constants/app-constants";

const EChallanFaqsVariant = ({ challanFaqData }) => {

    const [viewAll, setViewAll] = useState(false);

    const {
        title = "",
        faqList = []
    } = challanFaqData || {};

    const threshold = NUMBER.FIVE;

    const accordionClickHandler = async (id) => {
        await yieldToMain();
        sendCustomGaEvents({ ...challanFaqClicked, eventLabel: id });
    };

    const showAllFaq = () => {
        setViewAll(prev => !prev);
    };

    return (
        <div styleName={"styles.faqMainWrapper"}>
            <div styleName={"styles.faqWrapper"}>
                {
                    faqList.length > 0 &&
                    <>
                        <PilotFaq
                            heading={title}
                            faqs={viewAll ? faqList : faqList?.slice(0, threshold)}
                            attachSchema={true}
                            accordionClickHandler={accordionClickHandler}
                            hasListElements={true}
                        />
                        {
                            faqList.length > threshold &&
                            <div styleName={"styles.allFaqWrapper"}>
                                <Button
                                    label={viewAll ? "View less" : "View more"}
                                    onClick={showAllFaq}
                                    variant="tertiary"
                                    size="small"
                                    suffixIcon={<ArrowIcon rotateBy={viewAll ? NUMBER.TWO_HUNDRED_SEVENTY : NUMBER.NINETY} />}
                                />
                            </div>
                        }
                    </>
                }
            </div>
        </div>
    );
};

EChallanFaqsVariant.propTypes = {
    challanFaqData: PropTypes.object
};

export default EChallanFaqsVariant;
